const toArray = value => {
  if (!value) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};

export const customTaxanomyIcon = '/static/img/Other-custom.svg';

const decodeBase64 = value => {
  const normalizedValue = String(value || '')
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  try {
    if (typeof atob === 'function') {
      return decodeURIComponent(
        Array.prototype.map
          .call(atob(normalizedValue), char => {
            return `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`;
          })
          .join('')
      );
    }
  } catch (e) {
    // Try Buffer fallback below.
  }

  try {
    if (typeof Buffer !== 'undefined') {
      return Buffer.from(normalizedValue, 'base64').toString('utf8');
    }
  } catch (e) {
    return '';
  }

  return '';
};

export const normalizeTaxanomyIconUrl = icon => {
  const iconUrl = String(icon || '').trim();

  if (!iconUrl) {
    return '';
  }

  const consoleThumbnailMatch = iconUrl.match(
    /^https:\/\/res-console\.cloudinary\.com\/([^/]+)\/thumbnails\/v1\/(image|video|raw)\/upload\/v(\d+)\/([^/]+)/
  );

  if (consoleThumbnailMatch) {
    const [, cloudName, resourceType, version, encodedPublicId] =
      consoleThumbnailMatch;
    const publicId = decodeBase64(encodedPublicId);
    return publicId
      ? `https://res.cloudinary.com/${cloudName}/${resourceType}/upload/v${version}/${publicId}`
      : '';
  }

  return /^(https?:\/\/|\/\/|data:image\/)/.test(iconUrl) ? iconUrl : '';
};

export const normalizeTaxanomyKey = value =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const normalizeTaxanomyIcons = icons =>
  toArray(icons)
    .map(item => {
      const id = item?.id;
      const name = item?.name;
      const icon = normalizeTaxanomyIconUrl(item?.icon);

      return id || name ? { id, name, icon } : null;
    })
    .filter(Boolean);

export const getTaxanomyIconOptions = (icons, fallbackIcons = []) => {
  const normalizedIcons = normalizeTaxanomyIcons(icons);
  const normalizedFallbackIcons = normalizeTaxanomyIcons(fallbackIcons);

  return normalizedIcons.length
    ? normalizedFallbackIcons.concat(normalizedIcons)
    : normalizedFallbackIcons;
};

export const getTaxanomyIconForItem = (icons, item) => {
  const itemKeys = [
    item?.id,
    item?.name,
    item?.label,
    item?.lable,
    item?.categoryName,
  ]
    .map(normalizeTaxanomyKey)
    .filter(Boolean);

  if (!itemKeys.length) {
    return null;
  }

  const normalizedIcons = normalizeTaxanomyIcons(icons);
  const matchedIcon = [...normalizedIcons].reverse().find(iconItem => {
    if (!iconItem.icon) {
      return false;
    }
    const iconKeys = [iconItem.id, iconItem.name]
      .map(normalizeTaxanomyKey)
      .filter(Boolean);
    return iconKeys.some(iconKey => itemKeys.includes(iconKey));
  });

  return matchedIcon?.icon || null;
};

export const getTaxanomyIconForDisplay = (icons, item) => {
  if (item?.isCustom) {
    return customTaxanomyIcon;
  }

  return getTaxanomyIconForItem(icons, item) || item?.icon || null;
};
